import Instagram from './instagram';

export default Instagram;
